import { render, staticRenderFns } from "./proofedStatus.vue?vue&type=template&id=088bc988&scoped=true"
import script from "./proofedStatus.vue?vue&type=script&lang=js"
export * from "./proofedStatus.vue?vue&type=script&lang=js"
import style0 from "./proofedStatus.vue?vue&type=style&index=0&id=088bc988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088bc988",
  null
  
)

export default component.exports